// Impresión de Reportes — popup + window.print(), mismo patrón que imprimirVenta.js / imprimirCaja.
// Sin RUC en el encabezado (a diferencia del resto de comprobantes del sistema).

function fmtS(n) {
  return `S/ ${parseFloat(n || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
function fmtN(n) {
  return parseFloat(n || 0).toLocaleString('es-PE', { maximumFractionDigits: 2 });
}
// Un producto vendido en más de un formato (ej. HUEVO en JABA y MEDIA JABA)
// sigue siendo una sola fila — la cantidad se imprime como la suma de cada
// formato en su propia unidad, igual que en pantalla (ver fmtFormatos en
// ReportesPage.jsx).
function fmtFormatos(formatos) {
  return (formatos || []).map(f => `${fmtN(f.qty)} ${f.unit_measure || ''}`.trim()).join(' + ');
}
function fmtDate(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (isNaN(d)) return String(v).slice(0, 10);
  return d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'America/Lima' });
}
// due_date es DATE pura (sin hora, medianoche UTC) — timeZone la correría un
// día atrás; se extrae el día calendario directo del string ISO, sin Date.
function fmtDateOnly(v) {
  if (!v) return '—';
  const m = String(v).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(v).slice(0, 10);
}
function fmtNow() {
  return new Date().toLocaleString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'America/Lima' });
}
function esc(v) {
  return String(v ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
const ESTADO_LABELS = { cancelled: 'ANULADA', completed: 'COMPLETADO', pending: 'PENDIENTE', partial: 'PARCIAL', paid: 'PAGADO' };
function estadoLabel(v) {
  return ESTADO_LABELS[String(v || '').toLowerCase()] || String(v || '').toUpperCase();
}

const TITULOS = {
  ventas: 'REPORTE DE VENTAS',
  compras: 'REPORTE DE COMPRAS',
  utilidades: 'REPORTE DE UTILIDADES',
  productos: 'REPORTE DE INVENTARIO',
  'almacen-ventas': 'REPORTE DE VENTAS POR PRODUCTO',
  'ventas-x-producto': 'REPORTE DE VENTAS POR PRODUCTO - DETALLE',
  'cuentas-cobrar': 'REPORTE DE CUENTAS POR COBRAR',
  'cuentas-pagar': 'REPORTE DE CUENTAS POR PAGAR',
  cobranzas: 'REPORTE DE COBRANZAS',
};

function kpiBoxes(items) {
  return `<div class="rp-kpis">${items.map(k => `
    <div class="rp-kpi-box">
      <div class="rp-kpi-label">${esc(k.label)}</div>
      <div class="rp-kpi-value">${esc(k.value)}</div>
    </div>`).join('')}</div>`;
}

function tabla(titulo, cols, rows) {
  if (!rows || rows.length === 0) {
    return `<div class="rp-seccion"><div class="rp-seccion-title">${esc(titulo)}</div><div class="rp-empty">Sin datos</div></div>`;
  }
  const head = cols.map(c => `<th style="text-align:${c.align || 'left'}">${esc(c.label)}</th>`).join('');
  const body = rows.map(r => `<tr>${cols.map(c => {
    const raw = r[c.key];
    const val = c.fmt ? c.fmt(raw, r) : esc(raw ?? '—');
    return `<td style="text-align:${c.align || 'left'}">${val}</td>`;
  }).join('')}</tr>`).join('');
  return `<div class="rp-seccion">
    <div class="rp-seccion-title">${esc(titulo)}</div>
    <table class="rp-table"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
  </div>`;
}

// Tabla "Ventas x Prod." — a diferencia de tabla(), cada fila de producto
// es un grupo: una fila de cabecera (nombre + totales) seguida de una fila
// por cada venta individual que compone ese total. Reemplaza el desglose
// expandible (solo en pantalla) por uno siempre visible, apto para imprimir.
function tablaVentasPorProductoDetalle(rows) {
  if (!rows || rows.length === 0) {
    return `<div class="rp-seccion"><div class="rp-seccion-title">Ventas por Producto — Detalle</div><div class="rp-empty">Sin datos</div></div>`;
  }
  const body = rows.map(r => {
    const cabecera = `<tr style="background:#f1f5f9;font-weight:800">
      <td colspan="3">${esc(r.product_name)}</td>
      <td style="text-align:right">${fmtFormatos(r.formatos)}</td>
      <td style="text-align:right">${r.special_condition ? `${fmtN(r.qty_unidad)} UND` : '—'}</td>
      <td style="text-align:right">${fmtS(r.total)}</td>
    </tr>`;
    const ventas = (r.ventas || []).map(v => {
      const doc = v.serie && v.sequence ? esc(`${v.document_type || ''} ${v.serie}-${v.sequence}`.trim()) : esc(v.sale_number || '—');
      return `<tr>
        <td>${fmtDate(v.sale_date)}</td>
        <td>${doc}</td>
        <td>${esc(v.client_name)}</td>
        <td style="text-align:right">${fmtN(v.quantity)} ${esc(v.unit_measure || '')}</td>
        <td style="text-align:right">${r.special_condition ? `${fmtN(v.qty_unidad)} UND` : '—'}</td>
        <td style="text-align:right">${fmtS(v.subtotal)}</td>
      </tr>`;
    }).join('') || `<tr><td colspan="6" class="rp-empty">Sin ventas individuales</td></tr>`;
    return cabecera + ventas;
  }).join('');
  return `<div class="rp-seccion">
    <div class="rp-seccion-title">Ventas por Producto — Detalle</div>
    <table class="rp-table"><thead><tr>
      <th>Fecha</th><th>Documento</th><th>Cliente</th>
      <th style="text-align:right">Cantidad</th><th style="text-align:right">Unidades</th><th style="text-align:right">Total S/</th>
    </tr></thead><tbody>${body}</tbody></table>
  </div>`;
}

function buildSecciones(tipo, data) {
  const t = data.tables || {};
  switch (tipo) {
    case 'ventas':
      return [
        tabla('Ventas por Producto', [
          { key: 'product_name', label: 'Producto' },
          { key: 'qty', label: 'Cantidad', align: 'right', fmt: (v, r) => `${fmtN(v)} ${r.unit_measure || ''}` },
          { key: 'qty_unidad', label: 'Unidades', align: 'right', fmt: (v, r) => r.special_condition ? `${fmtN(v)} UND` : '—' },
          { key: 'total', label: 'Total S/', align: 'right', fmt: fmtS },
        ], t.porProducto),
        tabla('Ventas por Vendedor', [
          { key: 'seller_name', label: 'Vendedor' },
          { key: 'n_ventas', label: 'N° Ventas', align: 'right' },
          { key: 'total', label: 'Total', align: 'right', fmt: fmtS },
        ], t.porVendedor),
        tabla('Detalle de Ventas', [
          { key: 'sale_date', label: 'Fecha', fmt: fmtDate },
          { key: 'sale_number', label: 'N° Venta' },
          { key: 'client_name', label: 'Cliente' },
          { key: 'total', label: 'Total', align: 'right', fmt: fmtS },
          { key: 'status', label: 'Estado', fmt: v => v === 'cancelled' ? 'ANULADA' : 'COMPLETADA' },
        ], t.detalle),
      ].join('');
    case 'compras':
      return [
        tabla('Compras por Proveedor', [
          { key: 'provider_name', label: 'Proveedor' },
          { key: 'n', label: 'N° Compras', align: 'right' },
          { key: 'total', label: 'Total', align: 'right', fmt: fmtS },
        ], t.porProveedor),
        tabla('Top Productos Comprados', [
          { key: 'product_name', label: 'Producto' },
          { key: 'qty', label: 'Cant.', align: 'right', fmt: fmtN },
          { key: 'total', label: 'Total', align: 'right', fmt: fmtS },
        ], t.topProductos),
        tabla('Detalle de Compras', [
          { key: 'purchase_date', label: 'Fecha', fmt: fmtDate },
          { key: 'purchase_number', label: 'N° Compra' },
          { key: 'provider_name', label: 'Proveedor' },
          { key: 'total', label: 'Total', align: 'right', fmt: fmtS },
          { key: 'status', label: 'Estado', fmt: v => v === 'cancelled' ? 'ANULADA' : 'COMPLETADA' },
        ], t.detalle),
      ].join('');
    case 'utilidades':
      return [
        tabla('Utilidad por Producto', [
          { key: 'product_name', label: 'Producto' },
          { key: 'ingresos', label: 'Ingresos', align: 'right', fmt: fmtS },
          { key: 'costo', label: 'Costo', align: 'right', fmt: fmtS },
          { key: 'utilidad', label: 'Utilidad', align: 'right', fmt: fmtS },
          { key: 'margen', label: 'Margen %', align: 'right', fmt: v => `${parseFloat(v || 0).toFixed(1)}%` },
        ], t.porProducto),
        tabla('Utilidad por Familia', [
          { key: 'family', label: 'Familia' },
          { key: 'ingresos', label: 'Ingresos', align: 'right', fmt: fmtS },
          { key: 'costo', label: 'Costo', align: 'right', fmt: fmtS },
          { key: 'utilidad', label: 'Utilidad', align: 'right', fmt: fmtS },
          { key: 'margen', label: 'Margen %', align: 'right', fmt: v => `${parseFloat(v || 0).toFixed(1)}%` },
        ], t.porFamilia),
      ].join('');
    case 'productos':
      return [
        tabla('Valorización por Almacén', [
          { key: 'warehouse_name', label: 'Almacén' },
          { key: 'n_productos', label: 'Productos', align: 'right' },
          { key: 'valor_costo', label: 'Valor Costo', align: 'right', fmt: fmtS },
          { key: 'valor_venta', label: 'Valor Venta', align: 'right', fmt: fmtS },
        ], t.valorizacionPorAlmacen),
        tabla('Stock Bajo Mínimo', [
          { key: 'sku', label: 'SKU' },
          { key: 'name', label: 'Producto' },
          { key: 'warehouse_name', label: 'Almacén' },
          { key: 'stock', label: 'Stock', align: 'right', fmt: fmtN },
          { key: 'min_stock', label: 'Mínimo', align: 'right', fmt: fmtN },
          { key: 'deficit', label: 'Déficit', align: 'right', fmt: fmtN },
        ], t.stockBajo),
        tabla('Sin Movimiento', [
          { key: 'sku', label: 'SKU' },
          { key: 'name', label: 'Producto' },
          { key: 'ultima', label: 'Última Venta/Mov.', fmt: v => v ? fmtDate(v) : 'Nunca' },
          { key: 'stock', label: 'Stock', align: 'right', fmt: fmtN },
        ], t.sinMovimiento),
      ].join('');
    case 'almacen-ventas':
      return [
        tabla('Ventas por Producto', [
          { key: 'product_name', label: 'Producto' },
          { key: 'formatos', label: 'Cantidad', align: 'right', fmt: fmtFormatos },
          { key: 'qty_unidad', label: 'Unidades', align: 'right', fmt: (v, r) => r.special_condition ? `${fmtN(v)} UND` : '—' },
          { key: 'total', label: 'Total S/', align: 'right', fmt: fmtS },
        ], t.porProducto),
      ].join('');
    case 'ventas-x-producto':
      return tablaVentasPorProductoDetalle(t.porProducto);
    case 'cuentas-cobrar':
      return [
        tabla('Antigüedad de Deuda', [
          { key: 'bucket', label: 'Rango' },
          { key: 'total', label: 'Saldo', align: 'right', fmt: fmtS },
        ], t.antiguedad),
        tabla('Saldos por Cliente', [
          { key: 'client_name', label: 'Cliente' },
          { key: 'n_cuentas', label: 'N° Cuentas', align: 'right' },
          { key: 'saldo', label: 'Saldo', align: 'right', fmt: fmtS },
        ], t.saldosPorCliente),
        tabla('Detalle de Cuentas', [
          { key: 'client_name', label: 'Cliente' },
          { key: 'sale_number', label: 'N° Venta' },
          { key: 'due_date', label: 'Vencimiento', fmt: fmtDateOnly },
          { key: 'amount', label: 'Monto', align: 'right', fmt: fmtS },
          { key: 'paid_amount', label: 'Cobrado', align: 'right', fmt: fmtS },
          { key: 'status', label: 'Estado' },
        ], t.detalle),
        tabla('Cobranzas por Tipo de Ingreso', [
          { key: 'payment_method', label: 'Forma de Pago' },
          { key: 'n', label: 'N° Cobros', align: 'right' },
          { key: 'total', label: 'Monto Total', align: 'right', fmt: fmtS },
        ], t.cobrosPorTipo),
      ].join('');
    case 'cuentas-pagar':
      return [
        tabla('Saldos por Proveedor', [
          { key: 'provider_name', label: 'Proveedor' },
          { key: 'n_cuentas', label: 'N° Cuentas', align: 'right' },
          { key: 'saldo', label: 'Saldo', align: 'right', fmt: fmtS },
        ], t.saldosPorProveedor),
        tabla('Detalle de Cuentas', [
          { key: 'provider_name', label: 'Proveedor' },
          { key: 'purchase_number', label: 'N° Compra' },
          { key: 'due_date', label: 'Vencimiento', fmt: fmtDateOnly },
          { key: 'amount', label: 'Monto', align: 'right', fmt: fmtS },
          { key: 'paid_amount', label: 'Pagado', align: 'right', fmt: fmtS },
          { key: 'status', label: 'Estado' },
        ], t.detalle),
      ].join('');
    case 'cobranzas': {
      const cabecera = data.cliente ? `<div class="rp-seccion">
        <div class="rp-seccion-title">CLIENTE: ${esc(data.cliente.client_name)}${data.cliente.document_number ? ' — ' + esc(data.cliente.document_number) : ''}</div>
      </div>` : '';
      const ventas = t.ventas || [];
      const bloques = ventas.length === 0
        ? `<div class="rp-seccion"><div class="rp-empty">Sin ventas a crédito en el rango seleccionado</div></div>`
        : ventas.map(v => {
            const doc = v.serie ? esc(`${v.document_type || ''} ${v.serie}-${v.sequence}`.trim()) : esc(v.sale_number || '—');
            const cobrosRows = (v.cobros || []).map(c => `
              <tr${c.anulado ? ' style="color:#94a3b8;text-decoration:line-through"' : ''}>
                <td>${c.cobranza_id ?? c.id}</td>
                <td>${fmtDate(c.paid_at)}</td>
                <td>${esc(c.payment_method)}</td>
                <td>${esc(c.username)}</td>
                <td style="text-align:right">${fmtS(c.amount)}</td>
                <td>${c.anulado ? 'ANULADO' : 'Activo'}</td>
              </tr>`).join('');
            const cobrosTabla = (v.cobros || []).length === 0
              ? `<div class="rp-empty" style="padding:4px 0">Sin cobros registrados</div>`
              : `<table class="rp-table" style="margin:4px 0 0">
                  <thead><tr><th>N° Cobro</th><th>Fecha Cobro</th><th>Forma de Pago</th><th>Usuario</th><th style="text-align:right">Monto</th><th>Estado</th></tr></thead>
                  <tbody>${cobrosRows}</tbody>
                </table>`;
            const saldoLine = v.restante > 0.009
              ? `<div style="text-align:right;font-weight:800;color:#dc2626;margin-top:4px">Saldo: ${fmtS(v.restante)}</div>` : '';
            return `<div class="rp-seccion" style="border:1px solid #ddd;border-radius:6px;padding:8px 10px;margin-bottom:8px">
              <div style="display:flex;gap:10px;align-items:center;font-weight:700;margin-bottom:4px">
                <span>${fmtDate(v.sale_date)} — ${doc}</span>
                <span>[${esc(estadoLabel(v.status))}]</span>
                ${v.descuadre ? '<span style="color:#dc2626">⚠ NO CUADRA</span>' : ''}
                <span style="margin-left:auto">${fmtS(v.amount)}</span>
              </div>
              ${cobrosTabla}
              ${saldoLine}
            </div>`;
          }).join('');
      return cabecera + bloques;
    }
    default:
      return '';
  }
}

/**
 * Imprime un reporte en formato A4.
 * @param {string} tipo - 'ventas'|'compras'|'utilidades'|'productos'|'almacen-ventas'|'ventas-x-producto'|'cuentas-cobrar'|'cuentas-pagar'
 * @param {object} data - respuesta del endpoint /api/reportes/<tipo>
 * @param {object} opts - { empresa: {name, address}, kpis: [{label, value}], filtrosDesc: string }
 */
export function imprimirReporte(tipo, data, { empresa, kpis, filtrosDesc }) {
  const win = window.open('', '_blank', 'width=900,height=750');
  if (!win) return;

  const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">
    <title>${esc(TITULOS[tipo] || 'Reporte')}</title>
    <style>
      @page { size: A4; margin: 14mm; }
      body { font-family: Arial, Helvetica, sans-serif; color: #1e293b; font-size: 12px; }
      .rp-header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #0d1b2e; padding-bottom: 10px; margin-bottom: 12px; }
      .rp-empresa-nombre { font-size: 16px; font-weight: 800; color: #0d1b2e; text-transform: uppercase; }
      .rp-empresa-linea { font-size: 11px; color: #64748b; }
      .rp-doc-box { text-align: right; }
      .rp-doc-title { font-size: 14px; font-weight: 800; color: #0ea5e9; text-transform: uppercase; }
      .rp-doc-linea { font-size: 11px; color: #64748b; }
      .rp-kpis { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
      .rp-kpi-box { flex: 1; min-width: 110px; border: 1px solid #e2e8f0; border-radius: 6px; padding: 8px 10px; }
      .rp-kpi-label { font-size: 9px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: .3px; }
      .rp-kpi-value { font-size: 14px; font-weight: 800; color: #0d1b2e; margin-top: 2px; }
      .rp-seccion { margin-bottom: 14px; }
      .rp-seccion-title { font-size: 11px; font-weight: 800; color: #0d1b2e; text-transform: uppercase; letter-spacing: .3px;
        border-bottom: 1px solid #e2e8f0; padding-bottom: 4px; margin-bottom: 6px; }
      .rp-table { width: 100%; border-collapse: collapse; font-size: 10.5px; }
      .rp-table th { background: #f1f5f9; color: #475569; font-weight: 700; padding: 5px 7px; text-align: left; font-size: 9.5px; text-transform: uppercase; }
      .rp-table td { padding: 4px 7px; border-bottom: 1px solid #f1f5f9; }
      .rp-empty { color: #94a3b8; font-size: 11px; padding: 8px 0; }
      .rp-footer { margin-top: 16px; padding-top: 8px; border-top: 1px solid #e2e8f0; display: flex; justify-content: space-between; font-size: 9.5px; color: #94a3b8; }
    </style>
    </head><body>
      <div class="rp-header">
        <div>
          <div class="rp-empresa-nombre">${esc(empresa?.name || 'PIVASAPOLLOS')}</div>
          ${empresa?.address ? `<div class="rp-empresa-linea">${esc(empresa.address)}</div>` : ''}
        </div>
        <div class="rp-doc-box">
          <div class="rp-doc-title">${esc(TITULOS[tipo] || 'Reporte')}</div>
          ${filtrosDesc ? `<div class="rp-doc-linea">${esc(filtrosDesc)}</div>` : ''}
          <div class="rp-doc-linea">Generado: ${fmtNow()}</div>
        </div>
      </div>
      ${kpiBoxes(kpis || [])}
      ${buildSecciones(tipo, data)}
      <div class="rp-footer">
        <span>${esc(empresa?.name || 'PIVASAPOLLOS')}</span>
        <span>Generado por el sistema — ${fmtNow()}</span>
      </div>
      <script>window.onload = () => { setTimeout(() => window.print(), 300); };</script>
    </body></html>`;

  win.document.write(html);
  win.document.close();
}
